import React from "react";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Card from "@mui/material/Card";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { green, red } from "@mui/material/colors";

const CategoriesRegistrationStatus = ({ entries, rejected, t }) => {
    return (
        <Box>
            {entries?.length > 0 && (
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography variant="h6" component="div">
                            {t("reg.status.accepted")}
                        </Typography>
                        <List>
                            {entries.map(c => {
                                const additionalD =
                                    c.additionalDescription !== undefined && c.additionalDescription !== null ? ` (${c.additionalDescription})` : "";
                                return (
                                    <ListItem key={c.id} disablePadding>
                                        <ListItemAvatar>
                                            <Avatar sx={{ bgcolor: green[500], width: 24, height: 24 }}>
                                                <CheckIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText id={`cat-lab-${c.id}`} primary={`${c.name}${additionalD}`} />
                                    </ListItem>
                                );
                            })}
                        </List>
                    </CardContent>
                </Card>
            )}
            {rejected?.length > 0 && (
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography variant="h6" component="div">
                            {t("reg.status.rejected")}
                        </Typography>
                        <List>
                            {rejected.map(({ 0: c, 1: reason }) => {
                                const additionalD = c.additionalDescription !== null ? ` (${c.additionalDescription})` : "";
                               // console.log(reason);
                                const reasonTxt =
                                    reason.regOpen === false
                                        ? t("reg.status.reason.reg_open")
                                        : reason.age === false
                                        ? t("reg.status.reason.age")
                                        : reason.class === false
                                        ? t("reg.status.reason.class")
                                        : reason.licence === false
                                        ? t("reg.status.reason.licence")
                                        : reason.style === false
                                        ? t("reg.status.reason.style")
                                        : reason.limits === false
                                        ? t("reg.status.reason.limits")
                                        : reason.count === false
                                        ? t("reg.status.reason.count")
                                        : reason.codeOk === false
                                        ? t("reg.status.reason.code")
                                        : t("reg.status.reason.unknown");

                                return (
                                    <ListItem key={c.id} disablePadding>
                                        <ListItemAvatar>
                                            <Avatar sx={{ bgcolor: red[500], width: 24, height: 24 }}>
                                                <ClearIcon />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText id={`cat-lab-${c.id}`} primary={`${c.name}${additionalD}`} secondary={reasonTxt} />
                                    </ListItem>
                                );
                            })}
                        </List>
                    </CardContent>
                </Card>
            )}
        </Box>
    );
};

export default CategoriesRegistrationStatus;
